import { useEffect, useState } from 'react'
import Loading from '../../../../load/loading';
import RegisterAccess from '../../../../utils/registerAccess';
import HeaderSession from '../../../../utils/headerSession';
import { Box, Button, Container, InputBase, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import api from '../../../../services/api';
import MessageError from '../../../../messages/messageError';
import Montante from '../../../../utils/montante';
import GetDoc from '../../../../utils/getDoc';

const FinancasPage = () => {
    const [loading, setLoading] = useState(false);
    const [emolumentoCriado, setEmolumentoCriado] = useState([]);
    const [messageError, setMessageError] = useState('');
    const [filter, setFilter] = useState('')


    useEffect(() => {
        setLoading(true)
        api.get(`/emolumentos?perPage=200`)
            .then((response) => {
                setLoading(false);
                setEmolumentoCriado(response.data.emolumentos || []);
                setFilter(response.data.emolumentos);
            })
            .catch((err) => {
                setLoading(false);
                setMessageError(err.response?.data?.message || 'Erro ao buscar emolumentos');
            });

    }, []);

    // FILTRO DE INFORMACOES
    const filtraInformacoes = (valor) => {
        setEmolumentoCriado(filter.filter((emolumento) => (emolumento?.designacao?.toLowerCase().includes(valor.toLowerCase()))))
    }


    return (
        <Container style={{ minHeight: '73vh', }}>
            <RegisterAccess page={'Taxas e Emolumentos'} />
            <HeaderSession title={'TAXAS E EMOLUMENTOS'} />

            {messageError && <MessageError message={messageError} />}

            <Box display={'flex'}>
                <InputBase
                    style={{ width: '100%', border: '1px solid #85287e', borderRadius: 5, paddingLeft: 20 }}
                    // sx={{ ml: 1, flex: 1 }}
                    autoFocus
                    placeholder="Filtra aquí as informações"
                    inputProps={{ 'aria-label': 'Filtrar lista' }}
                    onChange={(e) => { filtraInformacoes(e.target.value) }}
                />
                <GetDoc title={' DIÁRIO DA REPÚBLICA '} id={'692ed0810db7a0e2f87d7586'} />
            </Box>

            <div style={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>
                <Box>
                    <TableContainer sx={{ border: "1px black" }} component={Paper}>
                        <Table sx={{ border: "1px", borderColor: "black" }}>
                            <TableHead sx={{ backgroundColor: "#dcdede" }}>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}><strong>Designação</strong></TableCell>
                                    <TableCell align='left' sx={{ fontWeight: 'bold' }}><strong>Valor</strong></TableCell>
                                    {/* <TableCell sx={{ fontWeight: 'bold' }}>Açōes</TableCell> */}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    (emolumentoCriado.map((emolumento, index) => (
                                        <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell style={{ fontSize: 16 }}>{emolumento?.designacao}</TableCell>
                                            <TableCell align='left'><Typography noWrap> <Montante montante={emolumento?.valor} /></Typography></TableCell>
                                            {/* <TableCell align='left'>
                                                <Button variant="contained" style={{ backgroundColor: '#99288b', cursor: 'pointer', fontSize: '11px' }}>Gerar Rupe</Button>
                                            </TableCell> */}
                                        </TableRow>
                                    )))
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>

                {loading && <Loading text={'A carregar emolumentos...'} />}
            </div>
        </Container>
    )
}

export default FinancasPage
